module.exports = __webpack_public_path__ + "media/frontend/svg/information1-d2b7a232fd715d8c3f11c44d4f29e80a.svg";